import _ from 'lodash'

import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

/* TODO:
 * 1. How to get fhir_const for `updated_at`
 * 2. how to use transaction and 2 mappings for one form
   3. What data should be used in `Performer` and where to get it
   4. How to form issued correctly
 * */
/* const mapping = [
 *   {
 *     fhir: ['resourceType'],
 *     fhir_const: 'Bundle'
 *   },
 *   {
 *     fhir: ['type'],
 *     fhir_const: 'transaction'
 *   },
 *   {
 *     fhir: diagnosticReport('59408-5', 'Body Temperature', 'f'),
 *     form: ['dianosticReport']
 *   },
 * ];
 * */

const informantEx = {
  url: 'http://narus.com/fhir/diagnosticreport-informant'
}

const uploadedByEx = {
  url: 'http://narus.com/fhir/diagnosticreport-uploadedBy'
}

const securityEx = {
  url: 'http://hl7.org/fhir/v3/Confidentiality'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'DiagnosticReport'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'status' ],
    fhir_const: 'current'
  },
  {
    fhir: [ 'presentedForm', 0, 'creation' ],
    form: [ 'uploaded' ]
  },
  {
    fhir: [ 'presentedForm', 0, 'contentType' ],
    form: [ 'attachedFileMeta', 'mime_type' ]
  },
  {
    fhir: [ 'presentedForm', 0, 'size' ],
    form: [ 'attachedFileMeta', 'size' ]
  },
  {
    fhir: [ 'presentedForm', 0, 'title' ],
    form: [ 'attachedFileMeta', 'filename' ]
  },
  {
    fhir: [ 'presentedForm', 0, 'hash' ],
    form: [ 'attachedFileMeta', 'id' ]
  },
  {
    fhir: [ 'presentedForm', 0, 'language' ],
    fhir_const: 'en'
  },
  {
    fhir: [ 'issued' ],
    fhir_const: form2fhir(new Date())
  },
  {
    fhir: [ 'category', 'coding', 0 ],
    form: [ 'category' ]
  },
  {
    fhir: [ 'code', 'text' ],
    form: [ 'type' ]
  },
  {
    fhir: [ 'effectiveDateTime' ],
    form: [ 'performed' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'extension', informantEx, 'valueReference', 'display' ],
    form: [ 'source' ]
  },
  {
    fhir: [ 'performer', 0, 'display' ],
    form: [ 'performer' ]
  },
  {
    fhir: [ 'extension', uploadedByEx, 'valueReference', 'reference' ],
    form: [ 'uploadedBy', 'reference' ]
  },
  {
    fhir: [ 'extension', uploadedByEx, 'valueReference', 'display' ],
    form: [ 'uploadedBy', 'display' ]
  },
  {
    fhir: [ 'extension', securityEx, 'valueReference', 'display' ],
    form: [ 'mPower' ],
    to_fhir: v => {
      let nv = 'N'
      if (v) {
        nv = 'R'
      }
      return nv
    },
    to_form: v => {
      let nv = false
      if (v === 'R') {
        nv = true
      }
      return nv
    }
  }
]

export function toFHIR (data, ptId) {
  const res = transform(data, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${ptId}` }
  res.subject = ptRef
  return res
}

export function fromFHIR (data) {
  const res = transform(data, mapping, [ 'fhir', 'form' ])
  res.updated_at = _.get(data, 'meta.lastUpdated')
  return res
}
